import { CallContent } from "../../../Components/CallApp/CallApp";

export const InfluencerCallContent: CallContent[] = [
  {
    Contact: "Noah",
    date: "Mon 27 May 2024",
    time: "1:12 AM",
    type: "missed",
  },
  {
    Contact: "Noah",
    date: "Mon 27 May 2024",
    time: "12:57 AM",
    type: "missed",
  },
  {
    Contact: "Rosa 💕",
    date: "Sun 26 May 2024",
    time: "7:05 PM",
    type: "incoming",
  },
  {
    Contact: "Rosa 💕",
    date: "Sun 26 May 2024",
    time: "7:04 PM",
    type: "incoming",
  },
  {
    Contact: "Mama M",
    date: "Sun 26 May 2024",
    time: "3:12 PM",
    type: "incoming",
  },
  {
    Contact: "Danny",
    date: "Sun 26 May 2024",
    time: "12:08 PM",
    type: "missed",
  },
  {
    Contact: "Rosa 💕",
    date: "Sat 25 May 2024",
    time: "5:07 PM",
    type: "incoming",
  },
  {
    Contact: "Danny",
    date: "Sat 25 May 2024",
    time: "2:25 PM",
    type: "incoming",
  },
];
